import { render, staticRenderFns } from "./ArmasPersonalList.vue?vue&type=template&id=f4dd63aa"
import script from "./ArmasPersonalList.vue?vue&type=script&lang=js"
export * from "./ArmasPersonalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports